import { ComponentPropsWithRef } from "react";
import styled from "@emotion/styled";
import { DatePicker } from "antd";

export const StyledRangePicker = styled(DatePicker.RangePicker)`
    /* Add your custom styles here */
` as React.FC<ComponentPropsWithRef<typeof DatePicker.RangePicker>>;
